import React from 'react';
import { Link } from 'react-router-dom';

function Testimonials() {
  const testimonials = [
    {
      name: "Sarah Chen",
      school: "James Ruse Agricultural High School",
      year: "2025",
      score: "Top 10% in all subjects",
      image: "👧",
      text: "PrepSmart helped me ace the selective school test! The topic-based practice was exactly what I needed to improve my weak areas. I got into my dream school!",
      rating: 5
    },
    {
      name: "Michael Kumar",
      school: "Sydney Boys High School",
      year: "2025",
      score: "Top 10% in Reading & Math",
      image: "👦",
      text: "The mock tests were incredibly realistic. The timer and question navigator made me feel prepared for the actual exam day. Highly recommend!",
      rating: 5
    },
    {
      name: "Emma Wilson",
      school: "North Sydney Girls High School",
      year: "2024",
      score: "Top 10% in Writing",
      image: "👧",
      text: "The writing studio with expert feedback was a game-changer. My writing improved so much in just a few weeks. Thank you PrepSmart!",
      rating: 5
    },
    {
      name: "David Lee",
      school: "Baulkham Hills High School",
      year: "2024",
      score: "Top 25% to Top 10% improvement",
      image: "👦",
      text: "I struggled with mathematical reasoning, but the detailed explanations and topic-based tests helped me understand concepts I was missing. Got accepted!",
      rating: 5
    },
    {
      name: "Priya Patel",
      school: "Hornsby Girls High School",
      year: "2025",
      score: "Top 25% in all subjects",
      image: "👧",
      text: "The analytics dashboard showed me exactly where to focus my study time. The progress tracking kept me motivated throughout my preparation.",
      rating: 5
    },
    {
      name: "James Thompson",
      school: "Fort Street High School",
      year: "2024",
      score: "Top 10% in Thinking Skills",
      image: "👦",
      text: "PrepSmart's practice tests are better than any other platform I tried. The questions are challenging and the instant feedback is invaluable.",
      rating: 5
    }
  ];

  const stats = [
    { number: "160+", label: "Practice Tests", icon: "📝" },
    { number: "4 Subjects", label: "Comprehensive Coverage", icon: "📚" },
    { number: "Free Start", label: "No Credit Card Required", icon: "✨" },
    { number: "Expert", label: "Writing Feedback", icon: "💡" }
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb' }}>
      {/* Hero Section */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '80px 20px',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '48px', fontWeight: 'bold', marginBottom: '20px' }}>
            Student Success Stories
          </h1>
          <p style={{ fontSize: '20px', opacity: '0.95', maxWidth: '700px', margin: '0 auto' }}>
            Hear from students who achieved their selective school dreams with PrepSmart
          </p>
        </div>
      </div>

      {/* Stats Section */}
      <div style={{ 
        maxWidth: '1200px', 
        margin: '-50px auto 60px',
        padding: '0 20px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '20px'
        }}>
          {stats.map((stat, index) => (
            <div key={index} style={{
              background: 'white',
              padding: '30px',
              borderRadius: '16px',
              textAlign: 'center',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              border: '2px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '10px' }}>{stat.icon}</div>
              <div style={{ fontSize: '36px', fontWeight: 'bold', color: '#4f46e5', marginBottom: '5px' }}>
                {stat.number}
              </div>
              <div style={{ fontSize: '16px', color: '#6b7280' }}>
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Testimonials Grid */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '30px'
        }}>
          {testimonials.map((testimonial, index) => (
            <div key={index} style={{
              background: 'white',
              borderRadius: '16px',
              padding: '30px',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              border: '2px solid #e5e7eb',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.15)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
            }}
            >
              {/* Rating Stars */}
              <div style={{ marginBottom: '15px' }}>
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} style={{ fontSize: '20px', color: '#fbbf24' }}>⭐</span>
                ))}
              </div>

              {/* Testimonial Text */}
              <p style={{
                fontSize: '15px',
                lineHeight: '1.7',
                color: '#374151',
                marginBottom: '20px',
                fontStyle: 'italic'
              }}>
                "{testimonial.text}"
              </p>

              {/* Student Info */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
                paddingTop: '20px',
                borderTop: '1px solid #e5e7eb'
              }}>
                <div style={{
                  fontSize: '48px',
                  width: '60px',
                  height: '60px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  {testimonial.image}
                </div>
                <div>
                  <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1f2937' }}>
                    {testimonial.name}
                  </div>
                  <div style={{ fontSize: '14px', color: '#6b7280' }}>
                    {testimonial.school}
                  </div>
                  <div style={{ fontSize: '13px', color: '#10b981', fontWeight: '600' }}>
                    {testimonial.score} • Class of {testimonial.year}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
        color: 'white',
        padding: '80px 20px',
        textAlign: 'center',
        marginTop: '60px'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '36px', fontWeight: 'bold', marginBottom: '20px' }}>
            Ready to Join Our Success Stories?
          </h2>
          <p style={{ fontSize: '18px', opacity: '0.95', marginBottom: '30px' }}>
            Start your journey to selective school success today with PrepSmart
          </p>
          <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/register" style={{ textDecoration: 'none' }}>
              <button className="btn-primary" style={{
                padding: '16px 40px',
                fontSize: '18px',
                fontWeight: 'bold',
                background: 'white',
                color: '#4f46e5'
              }}>
                Get Started Free
              </button>
            </Link>
            <Link to="/pricing" style={{ textDecoration: 'none' }}>
              <button className="btn-secondary" style={{
                padding: '16px 40px',
                fontSize: '18px',
                fontWeight: 'bold',
                background: 'rgba(255,255,255,0.2)',
                border: '2px solid white'
              }}>
                View Pricing
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
